import React from 'react';
import { useFormContext } from 'react-hook-form';
import DOMPurify from 'dompurify';

const SanitizedInput = ({ name, register, ...rest }) => {
  const sanitizedRegister = {
    ...register(name),
    onChange: (event) => {
      event.target.value = DOMPurify.sanitize(event.target.value);
      register(name).onChange(event);
    },
  };

  return <input {...rest} {...sanitizedRegister} />;
};

export default SanitizedInput;
